import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

/**
 * A custom element that allows the user to select a quantity in the cart.
 * Extends QuantitySelectorComponent but uses absolute max limits instead of effective max.
 * Semantics: "What should the total quantity BE in the cart" vs "How many to ADD to cart"
 *
 * @extends {QuantitySelectorComponent}
 */
export class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  /**
   * Gets the effective maximum value for cart quantity selector
   * Cart page: uses absolute max (how much can be in cart total)
   * @returns {number | null} The effective max, or null if no max
   */
  getEffectiveMax() {
    const { max } = this.getCurrentValues();
    return max; // Cart uses absolute max, not max minus cart quantity
  }

  /**
   * Updates button states based on current value and limits
   * Cart buttons are always managed client-side, never server-disabled
   */
  updateButtonStates() {
    const { minusButton, plusButton } = this.refs;
    const { min, value } = this.getCurrentValues();
    const effectiveMax = this.getEffectiveMax();

    // Cart buttons are always dynamically managed
    const minusOff = value <= min;
    const plusOff = effectiveMax !== null && value >= effectiveMax;

    // Varmth core patch GA3 (G-A polish, 9 Oct; R3-07, WCAG 2.4.3): a focused stepper button that is about
    // to be disabled (2 -> 1 on minus, max on plus) hands focus to the other button, or to the input,
    // instead of dropping it to <body>.
    const active = document.activeElement;
    if (minusOff && active === minusButton) (plusOff ? this.refs.quantityInput : plusButton).focus();
    if (plusOff && active === plusButton) (minusOff ? this.refs.quantityInput : minusButton).focus();

    minusButton.disabled = minusOff;
    plusButton.disabled = plusOff;
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define('cart-quantity-selector-component', CartQuantitySelectorComponent);
}
